import React from 'react';
import { Link } from "react-router-dom"
import { Tooltip } from 'antd'
import image from "../../../bvmlogo.png"
import { getToken } from "../../../app/config"
import {connect} from "react-redux";

class Header extends React.Component {
  render() {
    const { userDetails, path } = this.props
    const match = path && path.split("/").indexOf("admin")
    return (
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo03"
                aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"/>
        </button>
        <a className="navbar-brand" href="/">
          <img src={image} width="30" height="30" alt=""/>
        </a>

        <div className="collapse navbar-collapse" id="navbarTogglerDemo03">
          <ul className="navbar-nav mr-auto mt-2 mt-lg-0"/>
          <form className="form-inline my-2 my-lg-0">
            <input className="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search"/>

            { getToken() ?
              <div>
                <Tooltip placement="bottom" title="User Profile">
                  <Link to="/profile">
                    <button className={path === "/profile" ? "btn btn-secondary" : "btn btn-light"} type="submit" >
                      <i className="fas fa-user"
                         style={{fontSize: 25}}
                      />
                    </button>
                  </Link>
                </Tooltip>
                { userDetails && userDetails.role === "admin" ?
                  <Tooltip placement="bottom" title="Admin View">
                    <Link to="/admin/ringtones-wallpapers">
                      <button className={match !== -1 ? "btn btn-secondary" : "btn btn-light"} type="submit">
                        <i
                          className="fas fa-user-cog"
                          style={{fontSize: 25}}
                        />
                      </button>
                    </Link>
                  </Tooltip> : null
                }
              </div> :
              <button className="btn btn-primary" type="submit" onClick={() => this.props.onRedirect("/signin")}>Upload</button>
            }

          </form>
        </div>

      </nav>
    );
  }
}

// export default Header;
const mapStateToProps = state => {
  return {
    userDetails: state && state.loginUser
  };
};

export default connect(mapStateToProps)(Header);